<template>
  <div class="create-edit-pet-modal petit-nature-modal" id="printPetDetails">
    <div class="header">
      <h1 class="subtitle is-4">Entregas efetuadas</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <div class="body">
      <div class="columns is-variable is-multiline">
        <div class="column is-6">
          <span class="label">Dono</span>
          <span>{{ pet.owner.name }}</span>
        </div>
        <div class="column is-6">
          <span class="label">Nome</span>
          <span>
            {{ pet.name }}
          </span>
        </div>
        <div class="column is-6">
          <span class="label">Idade</span>
          <span>
            {{ petAge }}
          </span>
        </div>
        <div class="column is-6">
          <span class="label">Consumo</span>
          <span>{{ pet.consumption }}g</span>
        </div>
        <div class="column is-12">
          <span class="label">Restrições</span>
          <div class="table-holder" v-if="pet.ingredients.length">
            <table class="table">
              <thead>
                <tr>
                  <th>Ingredientes</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="restriction in pet.ingredients"
                  :key="restriction.id"
                >
                  <td>{{ restriction.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="column is-12" v-else>
            <div class="no-items-message has-text-centered is-centered">
              Esse pet não possui restrições
            </div>
          </div>
        </div>
        <div class="column is-12" v-if="petDeliveries.length">
          <label class="label">Entregas</label>
          <div class="table-holder">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Receita</th>
                  <th>Lote</th>
                  <th>Quantidade</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="delivery in petDeliveries" :key="delivery.id">
                <td>{{delivery.deliveryDate | moment("DD/MM/YYYY")}}</td>
                <td>{{delivery.receipt}}</td>
                <td>{{delivery.batch}}</td>
                <td>{{delivery.quantity}} x {{delivery.packageSize}}g</td>
              </tr></tbody>
            </table>
          </div>
        </div>

        <div class="column is-12" v-else>
          <div class="no-items-message has-text-centered is-centered">
            Esse pet não recebeu nenhuma entrega.
          </div>
        </div>
      </div>
    </div>
    <div class="footer has-text-right is-print-hidden">
      <button class="button is-primary" @click="print" :disabled="isLoading">
        Imprimir
      </button>
    </div>
  </div>
</template>

<script>
import DeliveryService from "../../services/DeliveryService";
import * as moment from 'moment';
export default {
  name: "PetDetailsComponent",
  props: { pet: {} },
  data: function() {
    return { petDeliveries: [], isLoading: true, petAge: "" };
  },
  methods: {
    print() {
      this.$htmlToPaper("printPetDetails");
    },
    getPetDeliveries() {
      this.isLoading = true;
      DeliveryService.getPetDeliveries(this.pet.id)
        .then(({ data }) => {
          let date = new Date().getTime();
          this.setPetAge();
          this.petDeliveries = data.content.map((d, i) => {
            d.id = date + i;
            return d;
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setPetAge() {
      if (!this.pet.dateOfBirth){
        return;
      }
      const years = moment().diff(this.pet.dateOfBirth, "years");
      const months = moment().diff(this.pet.dateOfBirth, "months") - years * 12;
      this.petAge = `${years} anos e ${months} meses`;
    }
  },
  beforeMount() {
    this.getPetDeliveries();
  }
};
</script>

<style scoped>
</style>
